import { useCallback, useState } from 'react';
import useSettings from 'data/hooks/useSettings';
import usePrinterStatus from 'data/hooks/usePrinterStatus';
import useSettingsActions from 'data/hooks/useSettingsActions';
import { initialValues, FormValues } from './constants';

const useConnect = () => {
  const { general, isLoading } = useSettings();
  const { printerStatus } = usePrinterStatus();
  const { testPrinter, updateGeneral } = useSettingsActions();
  const [selectedBrandId, setSelectedBrandId] = useState<string>('');

  const handleSubmit = useCallback(
    async (values: FormValues) => {
      try {
        const { printerCopies } = values;
        await updateGeneral({ printerCopies: parseInt(printerCopies, 10) });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    },
    [updateGeneral],
  );

  return {
    printerStatus,
    general,
    isLoading,
    testPrinter,
    handleSubmit,
    initialValues,
    selectedBrandId,
    setSelectedBrandId,
  };
};

export default useConnect;
